import { getToken } from './auth';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5134';

async function request(method, path, body) {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw Object.assign(new Error(err.error || res.statusText), { status: res.status });
  }
  return res.status === 204 ? null : res.json();
}

async function getBlob(path) {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw Object.assign(new Error(err.error || res.statusText), { status: res.status });
  }
  return res.blob();
}

export const api = {
  get:     (path)         => request('GET',    path),
  post:    (path, body)   => request('POST',   path, body),
  put:     (path, body)   => request('PUT',    path, body),
  delete:  (path)         => request('DELETE', path),
  getBlob,
};
